import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {useParams} from 'react-router-dom'
import {message} from 'antd'
import GroupForm from "../../components/groups/GroupForm";
import LayoutComponent from "../../components/shared/layout/Layout";
import {
    createNewGroupAction,
    getGroupDetailsAction,
    updateGroupDetailsAction,
    updateGroupStateValues,
    resetGroupInputsValues,
} from "../../store/actions/groups.action";
import {useHistory} from "react-router-dom";
import {searchPermissionsListAction} from "../../store/actions/permissions.action";
import ActionButtonsComponent from "../../components/shared/action-buttons/ActionButtons.component";

const CreateGroupPage = ({success, error, updateGroupStateValues,resetGroupInputsValues, id, loading, getGroupDetailsAction, selectedGroupInputs, selectedGroup, searchPermissionsListAction, updateGroupDetailsAction, createNewGroupAction}) => {
    const [viewMode, setViewMode] = useState(true)
    const [isNew, setIsNew] = useState(false)
    const idParam = useParams().id

    const navigate = useHistory();

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (success) {
            message.success(success);
            setViewMode(true);
            updateGroupStateValues({
                success: ''
            });
            if (isNew) {
                navigate.push(`/groups`);
            }
        }
    }, [navigate, id, isNew, success, updateGroupStateValues])

    useEffect(() => {
        resetGroupInputsValues(idParam)
        if (idParam !== 'new') {
            getGroupDetailsAction(idParam)
            setIsNew(false)
            setViewMode(true)
        } else {
            setViewMode(false)
            setIsNew(true)
        }

    }, [getGroupDetailsAction, idParam, resetGroupInputsValues]);

    useEffect(() => {
        console.log('searchPermissionsListAction');
        searchPermissionsListAction();
    }, [searchPermissionsListAction]);

    useEffect(() => {
        if (error) {
            message.error(error);
            updateGroupStateValues({
                error: null,
            })
            setViewMode(false)
        }
    }, [error, updateGroupStateValues])

    const onChangeInput = (e) => {
        const { name, value } = e.target;
        console.log({selectedGroup, selectedGroupInputs})

        updateGroupStateValues({
            selectedGroupInputs: {
                ...selectedGroupInputs,
                [name]: value,
            }
        });
    }
    // TODO Need to figure out why the method are not the correct redux state values
    const onCancel = () => {
        resetGroupInputsValues(isNew);
        setViewMode(true);
    };

    const onSave = () => {
        console.log('On Save');
        if (!isNew) {
            updateGroupDetailsAction(selectedGroupInputs);
        } else {
            createNewGroupAction(selectedGroupInputs);
        }
    }

    const onEdit = () => {
        console.log({selectedGroup, selectedGroupInputs, id, isNew})
        setViewMode(false);
    };
    return (
        <LayoutComponent loading={loading}>
            <GroupForm
                viewMode={viewMode}
                isNew={isNew}
                id={idParam}
                onChangeInput={onChangeInput}
            />
            <ActionButtonsComponent
                className='gap-8 right'
                labelMap={{
                    save: 'Save',
                    edit: 'Edit',
                    cancel: 'Cancel'
                }}
                handleSave={onSave}
                handleCancel={onCancel}
                handleEdit={onEdit}
                viewMode={viewMode}
                isNew={isNew}
            />
        </LayoutComponent>
    )
}

CreateGroupPage.propTypes = {
    loading: PropTypes.bool,
    success: PropTypes.string,
    id: PropTypes.number,
    error: PropTypes.string,
}

const mapStateToProps = ({ groupsState }) => {
    const selectedGroupInputs = groupsState.selectedGroupInputs;
    const selectedGroup = {...groupsState.selectedGroup};
    return {
        loading: groupsState.loading,
        success: groupsState.success,
        id: groupsState.id,
        error: groupsState.error,
        selectedGroupInputs,
        selectedGroup: Object.keys(selectedGroup).length ? selectedGroup : {firstName: 'initial'},
    }
}

export default
connect(mapStateToProps, {
    updateGroupStateValues,
    getGroupDetailsAction,
    searchPermissionsListAction,
    updateGroupDetailsAction,
    createNewGroupAction,
    resetGroupInputsValues,
})(CreateGroupPage)
